const ReqCode = Object.freeze({
  FAST: 1,
  STOP_BIOTIN: 2,
  NO_NY: 3,
  NO_NJ: 4,
  NO_AZ: 5, 
  NO_HI: 6, 
  LAB_ONLY: 7,
  MOBILE_PHLEB_ONLY: 8,
  FEMALE_ONLY: 9,
  MALE_ONLY: 10,
  FROZEN: 11,
})

export default ReqCode;